import InputField from "components/fields/InputField";
import logo from "assets/img/auth/cf-logo.jpg";
import { sendPasswordResetEmail, fetchSignInMethodsForEmail } from "firebase/auth";
import { useEffect, useState } from "react";
import { useAuth } from "context/AuthContext";
import { auth } from "services/firebase";

export default function SignIn() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = () => {
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    login(email, password);
  };

  const handleForgotPassword = async () => {
    if (!email) {
      alert("Por favor, preencha seu e-mail antes de solicitar a recuperação.");
      return;
    }

    try {
      const methods = await fetchSignInMethodsForEmail(auth, email);

      if (methods.length === 0) {
        alert("Por favor, preencha com um e-mail cadastrado.");
        return;
      }

      await sendPasswordResetEmail(auth, email);
      alert("E-mail de recuperação enviado para: " + email);

    } catch (error) {
      console.error("Erro ao verificar ou enviar e-mail de recuperação:", error);
      alert("Ocorreu um erro ao processar sua solicitação. Tente novamente.");
    }
  };

  return (
    <div className="mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <img
          className="mb-10 ml-1 w-[350px] h-auto"
          src={logo}
          alt="Controlfoods Logo"
          />

        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="email@exemplo.com"
          id="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <InputField
          variant="auth"
          extra="mb-3"
          label="Senha*"
          placeholder="Mínimo de 8 caracteres"
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <div className="mb-4 flex items-center justify-between px-2">
          <div className="flex items-center">
            <input
              type="checkbox"
              checked={rememberMe}
              onChange={(e) => setRememberMe(e.target.checked)}
              className="defaultCheckbox relative flex h-[20px] min-h-[20px] w-[20px] min-w-[20px] appearance-none items-center 
      justify-center rounded-md border border-gray-300 text-white/0 outline-none transition duration-200
      checked:border-none checked:text-white hover:cursor-pointer checked:bg-[#CF4949]"
            />
            <p className="ml-2 text-sm font-medium text-navy-700">
              Lembrar meu login
            </p>
          </div>

          <button
            type="button"
            onClick={handleForgotPassword}
            className="text-sm font-medium text-brand-500 hover:text-brand-600"
          >
            Esqueceu a senha?
          </button>
        </div>

        <button
          onClick={handleSubmit}
          className="mt-2 w-full rounded-full bg-[#CF4949] py-[12px] text-base font-bold text-white transition duration-200 hover:bg-[#B84343] active:bg-[#B84343]"
        >
          Acessar
        </button>

        <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700">
            Não tem um login?
          </span>
          <a
            href="mailto:comercial@controlfoods.com.br?subject=Solicitação de Acesso&body=Olá, eu gostaria de criar uma conta no Dashboard do ControlFoods"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600"
          >
            Solicitar uma conta
          </a>
        </div>

      </div>
    </div>
  );
}
